export default {
  computed: {
    telNoToHref: function () {
      return function (telNo) {
        return `tel:${telNo.replace(/[^+0-9]/g, '')}`
      }
    },
  },

  methods: {
    statusClass(status) {
      const conf = {
        reviewing: 'reviewing',
        confirming: 'confirming',
        under_selection: 'selection',
        interview_requested: 'request',
        interview_scheduled: 'scheduled',
        waiting_for_interview_result: 'waiting',
        offering: 'offering',
        employed: 'employed',
      }
      return conf[status]
    },

    closedStatus(closed) {
      const conf = {
        no: 'In Progress',
        yes: 'Closed',
      }
      return conf[closed]
    },
  },
}
